import { useParams } from 'react-router';
import { ROUTE_PATH } from '@/constants/routePaths';

type CollectionRouteParams = 'collectionId' | 'collectionName';

/**
 * Returns the href back to the collection the learner came through, or an empty
 * string when the course was not opened via a collection. The collection origin
 * is derived purely from the nested `/learning-collection/:collectionId/:collectionName`
 * route segments (see App.tsx), so a course opened via a direct link yields no href.
 */
export const useBackToCollectionHref = (): string => {
  const { collectionId, collectionName } = useParams<CollectionRouteParams>();

  return collectionId ? `${ROUTE_PATH.COLLECTION_BASE}/${collectionId}/${collectionName}` : '';
};
